import React from 'react';

import './FullPageSpinner.scss';

const FullPageSpinner = () => (
  <div className="spinner-page">
    <div className="spinner-page__spinner"></div>
  </div>
);

export default FullPageSpinner;